import { Stack, StackProps } from "@mui/material";
type PageContainerProps = StackProps & {};
export const PageContainer = (props: PageContainerProps) => {
  return (
    <Stack
      {...props}
      direction={"column"}
      flexGrow={1}
      overflow={"auto"}
      spacing={2}
      sx={{
        ...props.sx,
        borderTopLeftRadius: "12px",
        borderTopRightRadius: "12px",
        margin: "0 10px",
        padding: "16px 20px 0 20px",
        backgroundColor: (theme) => theme.palette.background.paper,
      }}
    >
      {props.children}
    </Stack>
  );
};
